import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const HeavyCongestionFilter = (props) => {
  const [selected, setSelected] = React.useState(
    localStorage.getItem("isHeavyCongestionOnlyChecked") === "true",
  );
  const allData = props.allData;
  const setFilteredData = props.setFilteredData;
  const handleChange = () => {
    setSelected((selected) => !selected);
  };
  React.useEffect(() => {
    if (selected) {
      const filteredData = {};
      Object.keys(allData).forEach((key) => {
        filteredData[key] = allData[key].filter(
          (data) => data.level === "Heavy",
        );
      });
      setFilteredData(filteredData);
    } else {
      setFilteredData(allData);
    }
    localStorage.setItem("isHeavyCongestionOnlyChecked", selected);
  }, [selected, allData, setFilteredData]);

  return (
    <FormControlLabel
      control={
        <Checkbox
          value={selected}
          checked={selected}
          onChange={handleChange}
          size="small"
          sx={{ ml: 3 }}
        />
      }
      label="Heavy Congestion Only"
    />
  );
};

export default HeavyCongestionFilter;
